export const isValidUrl = (url: string) => {
    const checkUrlRegex = /^(http(s)?:\/\/.)?[a-zа-я0-9~:_\-.]+\.[a-zа-я]{2,6}(\/?($|.+))*$/i;

    return new RegExp(checkUrlRegex).test(url);
};
